import { castToDate } from '@/utils/date.utils'

export default class DocumentDetails {
  private _documentType!: string
  private _documentId!: string | null
  private _documentTypeText!: string
  private _documentNumber!: string | null
  private _personType!: string | null
  private _file!: File | null
  private _fileName!: string | null
  private _mimeType!: string | null
  private _documentExpirationDate!: Date | null

  constructor(data: any = {}) {
    this.documentType = data.documentType || data._documentType
    this.documentTypeText = data.documentTypeText || data._documentTypeText
    this.documentNumber = data.documentNumber || data._documentNumber
    this.personType = data.personType || data._personType
    this.file = data.file || data._file
    this.documentId = data.documentId || data._documentId
    this.fileName = data.fileName || data._fileName
    this.mimeType = data.mimeType || data._mimeType
    this.documentExpirationDate = data.documentExpirationDate || data._documentExpirationDate
  }

  get documentType(): string {
    return this._documentType
  }
  set documentType(value: string | null | undefined) {
    this._documentType = value ?? ''
  }

  get documentExpirationDate(): Date | null {
    return this._documentExpirationDate
  }
  set documentExpirationDate(value: Date | null | undefined) {
    this._documentExpirationDate = castToDate(value ?? null)
  }

  get documentId(): string | null {
    return this._documentId
  }
  set documentId(value: string | null | undefined) {
    this._documentId = value ?? null
  }

  get documentTypeText(): string {
    return this._documentTypeText
  }
  set documentTypeText(value: string | null | undefined) {
    this._documentTypeText = value ?? 'NIF'
  }

  get documentNumber(): string | null {
    return this._documentNumber
  }
  set documentNumber(value: string | null | undefined) {
    this._documentNumber = value ?? null
  }

  get personType(): string | null {
    return this._personType
  }
  set personType(value: string | null | undefined) {
    this._personType = value ?? null
  }

  get file(): File | null {
    return this._file
  }
  set file(value: File | null | undefined) {
    this._file = value ?? null
  }

  get fileName(): string | null {
    return this._fileName
  }
  set fileName(value: string | null | undefined) {
    this._fileName = value ?? null
  }

  get mimeType(): string | null {
    return this._mimeType
  }
  set mimeType(value: string | null | undefined) {
    this._mimeType = value ?? null
  }

  updateAttributes(newAttributes: Partial<DocumentDetails>) {
    Object.assign(this, newAttributes)
  }
}
